$(document).ready(function () {
  // Vertical tabs controls
  $("#ess-vertical-tab1-desktop, #ess-vertical-tab1-mobile").click(function () {
    // Vertical tabs desktop
    $(".ess-vertical-tabs-desktop__tab.tab1").attr(
      "class",
      "ess-vertical-tabs-desktop__tab tab1 active"
    );
    $(".ess-vertical-tabs-desktop__tab.tab2").attr(
      "class",
      "ess-vertical-tabs-desktop__tab tab2"
    );
    $(".ess-vertical-tabs-desktop__tab.tab3").attr(
      "class",
      "ess-vertical-tabs-desktop__tab tab3"
    );
    $("#ess-vertical-content1-desktop").attr(
      "class",
      "row no-gutters ess-vertical-tabs-desktop__panel-content active"
    );
    $("#ess-vertical-content2-desktop").attr(
      "class",
      "row no-gutters ess-vertical-tabs-desktop__panel-content"
    );
    $("#ess-vertical-content3-desktop").attr(
      "class",
      "row no-gutters ess-vertical-tabs-desktop__panel-content"
    );
    // Vertical tabs mobile
    $(".ess-vertical-tabs-mobile__tab.tab1").attr(
      "class",
      "ess-vertical-tabs-mobile__tab tab1 active"
    );
    $(".ess-vertical-tabs-mobile__tab.tab2").attr(
      "class",
      "ess-vertical-tabs-mobile__tab tab2"
    );
    $(".ess-vertical-tabs-mobile__tab.tab3").attr(
      "class",
      "ess-vertical-tabs-mobile__tab tab3"
    );
    $("#ess-vertical-content1-mobile").attr(
      "class",
      "row no-gutters ess-vertical-tabs-mobile__panel-content active"
    );
    $("#ess-vertical-content2-mobile").attr(
      "class",
      "row no-gutters ess-vertical-tabs-mobile__panel-content"
    );
    $("#ess-vertical-content3-mobile").attr(
      "class",
      "row no-gutters ess-vertical-tabs-mobile__panel-content"
    );
  });
  $("#ess-vertical-tab2-desktop, #ess-vertical-tab2-mobile").click(function () {
    // Vertical tabs desktop
    $(".ess-vertical-tabs-desktop__tab.tab2").attr(
      "class",
      "ess-vertical-tabs-desktop__tab tab2 active"
    );
    $(".ess-vertical-tabs-desktop__tab.tab1").attr(
      "class",
      "ess-vertical-tabs-desktop__tab tab1"
    );
    $(".ess-vertical-tabs-desktop__tab.tab3").attr(
      "class",
      "ess-vertical-tabs-desktop__tab tab3"
    );
    $("#ess-vertical-content2-desktop").attr(
      "class",
      "row no-gutters ess-vertical-tabs-desktop__panel-content active"
    );
    $("#ess-vertical-content1-desktop").attr(
      "class",
      "row no-gutters ess-vertical-tabs-desktop__panel-content"
    );
    $("#ess-vertical-content3-desktop").attr(
      "class",
      "row no-gutters ess-vertical-tabs-desktop__panel-content"
    );
    // Vertical tabs mobile
    $(".ess-vertical-tabs-mobile__tab.tab2").attr(
      "class",
      "ess-vertical-tabs-mobile__tab tab2 active"
    );
    $(".ess-vertical-tabs-mobile__tab.tab1").attr(
      "class",
      "ess-vertical-tabs-mobile__tab tab1"
    );
    $(".ess-vertical-tabs-mobile__tab.tab3").attr(
      "class",
      "ess-vertical-tabs-mobile__tab tab3"
    );
    $("#ess-vertical-content2-mobile").attr(
      "class",
      "row no-gutters ess-vertical-tabs-mobile__panel-content active"
    );
    $("#ess-vertical-content1-mobile").attr(
      "class",
      "row no-gutters ess-vertical-tabs-mobile__panel-content"
    );
    $("#ess-vertical-content3-mobile").attr(
      "class",
      "row no-gutters ess-vertical-tabs-mobile__panel-content"
    );
  });
  $("#ess-vertical-tab3-desktop, #ess-vertical-tab3-mobile").click(function () {
    // Vertical tabs desktop
    $(".ess-vertical-tabs-desktop__tab.tab3").attr(
      "class",
      "ess-vertical-tabs-desktop__tab tab3 active"
    );
    $(".ess-vertical-tabs-desktop__tab.tab2").attr(
      "class",
      "ess-vertical-tabs-desktop__tab tab2"
    );
    $(".ess-vertical-tabs-desktop__tab.tab1").attr(
      "class",
      "ess-vertical-tabs-desktop__tab tab1"
    );
    $("#ess-vertical-content3-desktop").attr(
      "class",
      "row no-gutters ess-vertical-tabs-desktop__panel-content active"
    );
    $("#ess-vertical-content2-desktop").attr(
      "class",
      "row no-gutters ess-vertical-tabs-desktop__panel-content"
    );
    $("#ess-vertical-content1-desktop").attr(
      "class",
      "row no-gutters ess-vertical-tabs-desktop__panel-content"
    );
    // Vertical tabs mobile
    $(".ess-vertical-tabs-mobile__tab.tab3").attr(
      "class",
      "ess-vertical-tabs-mobile__tab tab3 active"
    );
    $(".ess-vertical-tabs-mobile__tab.tab2").attr(
      "class",
      "ess-vertical-tabs-mobile__tab tab2"
    );
    $(".ess-vertical-tabs-mobile__tab.tab1").attr(
      "class",
      "ess-vertical-tabs-mobile__tab tab1"
    );
    $("#ess-vertical-content3-mobile").attr(
      "class",
      "row no-gutters ess-vertical-tabs-mobile__panel-content active"
    );
    $("#ess-vertical-content2-mobile").attr(
      "class",
      "row no-gutters ess-vertical-tabs-mobile__panel-content"
    );
    $("#ess-vertical-content1-mobile").attr(
      "class",
      "row no-gutters ess-vertical-tabs-mobile__panel-content"
    );
  });
});

// Enable popovers
$(function () {
  $('[data-toggle="popover"]').popover();
});
$("#gunShopPopover").on("show.bs.popover", function () {
  $(".gun-shop-text").addClass("highlight");
});
$("#gunShopPopover").on("hide.bs.popover", function () {
  $(".gun-shop-text").removeClass("highlight");
});
